import { render, staticRenderFns } from "./driver.vue?vue&type=template&id=83cfafba&scoped=true&"
import script from "./driver.vue?vue&type=script&lang=js&"
export * from "./driver.vue?vue&type=script&lang=js&"
import style0 from "./driver.vue?vue&type=style&index=0&id=83cfafba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cfafba",
  null
  
)

export default component.exports